import React from 'react'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'

import Page from '../../index'
import Chip from '../../../components/Chip'
import Button from '../../../components/Button'
import SocialAuthorizeLogos from '../SocialAuthorizeLogos'
import InternalLink from '../../../components/InternalLink'

import { ROUTE_PARAMS, ROUTES } from '../../../constants/routes'
import { CHIP_COLORS } from '../../../constants/other'

import useStyles from './style'
import useCommonStyles from '../style'

function AdAccountAccessMissing() {
  const { t } = useTranslation()
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const { [ROUTE_PARAMS.adAccount]: selectedAdAccountId } = useParams()

  return (
    <Page helmetTitle="Ad Account Access Missing" className={commonClasses.socialAuthPage}>
      <SocialAuthorizeLogos />
      <h2 className={classes.header}>Ad account access missing</h2>
      <div className={classes.info}>
        {t('Sorry, the ad account with id')}
        <Chip className={classes.accountId} text={selectedAdAccountId} color={CHIP_COLORS.warning} />
        {t('is not valid, please return to the Campaigns page')}
      </div>
      <InternalLink to={ROUTES.campaigns}>
        <Button className={classes.btn}>{t('Go to campaigns')}</Button>
      </InternalLink>
    </Page>
  )
}

export default AdAccountAccessMissing
